import { useQuery } from '@tanstack/react-query';
import { ROUTES, type LogEntry } from '@serb/shared';
import { api, errorText } from '../../api/client';
import { KEYS } from '../../api/keys';
import { SAMPLE_DATA } from '../../lib/sample';
import { LOG } from './sample';

/** What Claude did and what you decided, newest first: read from the Serb Mind vault's logs (the sample log only while sample data is on) */
export function useActivity() {
  const q = useQuery({
    queryKey: KEYS.activity,
    queryFn: () => api.get<LogEntry[]>(ROUTES.api.activity),
    enabled: !SAMPLE_DATA,
  });
  return {
    items: SAMPLE_DATA ? LOG : (q.data ?? []),
    loading: !SAMPLE_DATA && q.isPending,
    error: q.isError ? errorText(q.error, 'The activity history could not be loaded.') : '',
  };
}
